module.exports = __webpack_public_path__ + "static/media/search_bar_icon.b6fdefe6.png";